var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleicon = function SvgGoogleicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M13.125 7.267c0-.443-.04-.87-.114-1.278H7.125v2.42h3.364a2.882 2.882 0 0 1-1.256 1.88v1.575h2.028c1.182-1.091 1.864-2.693 1.864-4.597Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M7.125 13.375c1.687 0 3.102-.557 4.136-1.511L9.233 10.29c-.557.375-1.267.602-2.108.602-1.625 0-3.006-1.096-3.5-2.574h-2.08v1.614a6.244 6.244 0 0 0 5.58 3.443Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M3.625 8.312a3.745 3.745 0 0 1-.199-1.187c0-.415.074-.813.199-1.188V4.324h-2.08c-.426.84-.67 1.79-.67 2.8 0 1.012.244 1.961.67 2.802l1.62-1.261.46-.353Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M7.125 3.364c.92 0 1.739.318 2.392.931l1.79-1.79C10.22 1.496 8.812.876 7.125.876a6.239 6.239 0 0 0-5.58 3.449l2.08 1.613c.494-1.477 1.875-2.573 3.5-2.573Z"
  })));
};
export default SvgGoogleicon;